import { render, staticRenderFns } from "./RegionalSettings.vue?vue&type=template&id=b6b2d59e&scoped=true"
import script from "./RegionalSettings.vue?vue&type=script&lang=js"
export * from "./RegionalSettings.vue?vue&type=script&lang=js"
import style0 from "./RegionalSettings.vue?vue&type=style&index=0&id=b6b2d59e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b2d59e",
  null
  
)

export default component.exports